<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/msg/config/robot/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jiqirenmingcheng')">
            <el-input v-model="yt.conditions.robotName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jiqirenleixing')">
            <yi_dictionary_select type="MSG_CONFIG_ROBOT_TYPE" :ids.sync="yt.conditions.robotType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_early_warning_management_msg_config_robot_create')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('tuisongxiaoxi', scope.row, null)" v-if="utils.checkPower('web_early_warning_management_msg_config_robot_pushMessage')">{{ $t('tuisongxiaoxi') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowEditDialogEdit)" v-if="utils.checkPower('web_early_warning_management_msg_config_robot_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/msg/config/robot/delete')" v-if="utils.checkPower('web_early_warning_management_msg_config_robot_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jiqirenmingcheng')" required>
            <el-input v-model="yt.editObj.robotName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jiqirenleixing')" required>
            <yi_dictionary_select type="MSG_CONFIG_ROBOT_TYPE" :ids.sync="yt.editObj.robotType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('webhook')" required>
            <el-input v-model="yt.editObj.webhook"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jiaqianmiyao')">
            <el-input v-model="yt.editObj.secret"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/msg/config/robot/create')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jiqirenmingcheng')" required>
            <el-input v-model="yt.editObj.robotName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jiqirenleixing')" required>
            <yi_dictionary_select type="MSG_CONFIG_ROBOT_TYPE" :ids.sync="yt.editObj.robotType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('webhook')" required>
            <el-input v-model="yt.editObj.webhook"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jiaqianmiyao')">
            <el-input v-model="yt.editObj.secret"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/msg/config/robot/update')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 推送消息 -->
      <template v-if="yt.editObj.action == 'tuisongxiaoxi'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xiaoxineirong')" required>
            <el-input type="textarea" :rows="4" :placeholder="$t('zheshiyitiaoceshixiaoxi')" v-model="yt.editObj.message"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="pushMessage(yt.editObj)" :loading="pushLoading" type="primary">{{ $t('tuisong') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_early_warning_management_msg_config_robot_list',
  data() {
    return {
      pushLoading: false,
      columns: [
        {
          label: 'jiqirenmingcheng',
          prop: 'robotName'
        },
        {
          label: 'jiqirenleixing',
          prop: 'robotType',
          type: 'dictionary_tag',
          key: 'MSG_CONFIG_ROBOT_TYPE'
        },
        {
          label: 'webhook',
          prop: 'webhook'
        },
        {
          label: 'jiaqianmiyao',
          prop: 'secret'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      row.robotType = '1';
      return row;
    },

    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      return row;
    },

    // 推送消息
    pushMessage(row) {
      let params = this.utils.copy(row);
      this.pushLoading = true;
      this.http
        .post('/web/msg/config/robot/push/message', params)
        .then(res => {
          if (res.data) {
            this.$message.success(this.$t('tuisongchenggong'));
            this.yt.isShowEditDialog = false;
          } else {
            this.$message.error(this.$t('tuisongshibai'));
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.pushLoading = false;
        });
    }
  }
};
</script>
